import { APPROVALS_SUBMIT_DECISION_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import {
	type ApprovalsWriteExperience,
	useApprovalsWriteExperience,
} from './useApprovalsWriteExperience.ts';

/**
 * Tracks `approvals/submit-decision` — an approver recorded approve or changes-requested.
 */
export const useSubmitDecisionExperience = (): ApprovalsWriteExperience =>
	useApprovalsWriteExperience(APPROVALS_SUBMIT_DECISION_EXPERIENCE);
